(function () {
const $c607fb3e0d37c6f8$var$$allTabButtons = [
    ...document.querySelectorAll('[data-tab-click]')
];
const $c607fb3e0d37c6f8$var$$allSections = [
    ...document.querySelectorAll('[aria-labelledby]')
];
const $c607fb3e0d37c6f8$var$$scrollTopButton = document.querySelector('[data-scroll-top]');
const $c607fb3e0d37c6f8$var$closeAllTabs = ()=>{
    for (const $singleTabButton of $c607fb3e0d37c6f8$var$$allTabButtons){
        $singleTabButton.setAttribute('aria-selected', 'false');
        $singleTabButton.setAttribute('tabindex', '-1');
    }
    for (const $singleSection of $c607fb3e0d37c6f8$var$$allSections)$singleSection.hidden = true;
};
const $c607fb3e0d37c6f8$var$handleTabSwitch = (event)=>{
    event.preventDefault();
    $c607fb3e0d37c6f8$var$closeAllTabs();
    const $clickedTabElement = event.target;
    const sectionID = $clickedTabElement.id;
    const $tabToShow = document.querySelector(`[aria-labelledby='${sectionID}']`);
    if ($tabToShow) {
        $tabToShow.hidden = false;
        $clickedTabElement.setAttribute('aria-selected', 'true');
        $clickedTabElement.setAttribute('tabindex', '');
    }
};
const $c607fb3e0d37c6f8$var$scrollTop = ()=>{
    window.scrollTo(0, 0);
};
$c607fb3e0d37c6f8$var$init();
function $c607fb3e0d37c6f8$var$init() {
    for (const $singleTabButton of $c607fb3e0d37c6f8$var$$allTabButtons)$singleTabButton.addEventListener('click', $c607fb3e0d37c6f8$var$handleTabSwitch);
    if ($c607fb3e0d37c6f8$var$$scrollTopButton) $c607fb3e0d37c6f8$var$$scrollTopButton.addEventListener('click', $c607fb3e0d37c6f8$var$scrollTop);
}

})();
//# sourceMappingURL=script.js.map
